export enum Status {
    AVAILABLE = "AVAILABLE",
    OCCUPIED = "OCCUPIED",
    FAULTED = "FAULTED",
    UNAVAILABLE = "UNAVAILABLE",
    NEW = "NEW",
    UNKNOWN = "UNKNOWN",
    RESERVED = "RESERVED",
    IN_PROVISION = "IN_PROVISION",
    CHARGING = "CHARGING",
    DISCHARGING = "DISCHARGING",
    PAUSED = "PAUSED",
    PREPARING = "PREPARING",
    FINISHING = "FINISHING"
}

export function isStatus(value: unknown): value is Status {
    return (Object.values(Status) as unknown[]).includes(value);
}

export interface Address {
    streetName: string;
    city: string;
    postalCode: string;
}

export interface Connector {
    id: string;
    smsCode: string;
    tariff: string;
    tariff_Unreg: string;
    connectorCategory: string;
    type: string;
    status: Status;
    maxEffect: number;
    startChargingScenario: string;
    // Id to poll the live status with, see getConnectorStatus
    driivzInternalId?: string;
}

export interface Evs {
    id: string;
    name: string;
    connectors: Connector[];
}

export interface Location {
    id: string;
    name: string;
    address: Address;
    evse: Evs;
}

export interface Charger {
    location: Location;
    success: boolean;
    description: string;
    errorCode: string;
}



